import { AttachMoney } from '@mui/icons-material';
import { Box, Grid, Typography } from '@mui/material';
import { getDocumentReport } from 'lib/api/document';
import { formatMoney } from 'lib/functions/utils';
import React from 'react';
import { useDispatch } from 'react-redux';

import InfoRow from './InfoRow';
import SectionSkeleton from './SectionSkeleton';

interface StateSectionProps {
  documentId: string;
}

const StateSection: React.FC<StateSectionProps> = ({ documentId }) => {
  const dispatch = useDispatch();
  const { data: document, isPending } = getDocumentReport(dispatch, documentId);

  if (!document || isPending) return <SectionSkeleton rowsPerColumn={2} />;
  const {
    arrearAmount,
    documentRemainingAmountNet,
    totalRemainingNet,
    creditNoteAmount,
  } = document;
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Box
        sx={{
          backgroundColor: 'rgba(76, 175, 80, 0.08)',
          borderRadius: '8px',
          px: 1.5,
          py: 0.8,
          border: '1px solid rgba(76, 175, 80, 0.15)',
          mt: 1,
        }}
      >
        <Typography
          variant="subtitle2"
          sx={{
            fontWeight: 600,
            color: 'success.main',
            fontSize: '0.75rem',
            textTransform: 'uppercase',
            letterSpacing: '0.5px',
            textAlign: 'center',
          }}
        >
          Estado actual
        </Typography>
      </Box>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <InfoRow
            label="Saldo mora"
            value={formatMoney(arrearAmount)}
            maxLength={40}
            icon={
              <AttachMoney sx={{ fontSize: '0.8rem', color: 'success.main' }} />
            }
          />
          <InfoRow
            label="Saldo capital"
            value={
              documentRemainingAmountNet
                ? formatMoney(documentRemainingAmountNet)
                : null
            }
            maxLength={40}
            icon={
              <AttachMoney sx={{ fontSize: '0.8rem', color: 'success.main' }} />
            }
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <InfoRow
            label="Saldo total"
            value={formatMoney(totalRemainingNet)}
            maxLength={40}
            icon={
              <AttachMoney sx={{ fontSize: '0.8rem', color: 'success.main' }} />
            }
          />
          <InfoRow
            label="Monto Nota de crédito"
            value={creditNoteAmount ? formatMoney(creditNoteAmount) : null}
            maxLength={40}
            icon={
              <AttachMoney sx={{ fontSize: '0.8rem', color: 'success.main' }} />
            }
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default StateSection;
